import { Tab } from "@headlessui/react";
import Button from "src/components/ui/button";
import classNames from "classnames";
import React, { useState } from "react";
import { User } from "src/api/types";
import {
  CurrencyDataType,
  TransactionDataType,
} from "src/lib/constants/table-type";
import { BackCircleIcon } from "src/components/icons/back-circle-icon";
import { capitalizeFirstLetter, getStatusStyle } from "src/lib/utils";
import UsersContainerPage from "src/components/users";
import { DateRangePicker } from "rsuite";
import moment from "moment";
import { DateRange } from "rsuite/esm/DateRangePicker";
import {
  billingTransactionSearchOptions,
  billingTransactionsFilterOptions,
  transactionFilterOptions,
  permissions as permissionConstants,
} from "src/lib/constants";
import SearchFilter_1 from "src/components/search-filters/billing-management-filter";
import SearchFilter_2 from "src/components/search-filters/user-management-filter_1";
import FeeManagementPage from "./fee-management";
import FeeManagementBusinessPage from "./fee-management-business";
import FeeBilling from "src/components/feeManagement/feeBilling";
import FeeBillingBusiness from "src/components/feeManagement/fee_billing_business";
import GamblingFeeBillingBusiness from "./gambling-fee-business-mgt";
import usePermissions from "src/hooks/use-permissions";

const tabLists = ["Fee management", "Billings", "Casino"];

const FeeMgtBusiness = () => {
  const { canView, canList } = usePermissions(
    permissionConstants.FEE_MANAGEMENT_BUSINESS
  );
  const canViewFeeMgtBusiness = canView || canList;

  const [selectedUser, setSelectedUser] = useState<User | null>(null);
  const [invoiceData, setInvoiceData] = useState<TransactionDataType | null>();
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [selectedUserID, setSelectedUserID] = useState(-1);
  const [dateRangeValue, setDateRangeValue] = useState<DateRange | null>(null);
  const [currencies, setCurrencies] = useState<CurrencyDataType[]>([]);
  const [searchText, setSearchText] = useState("");
  const [filter, setFilter] = useState("user_id");
  const [billingFilter, setBillingFilter] = useState("status");
  const [filterValue, setFilterValue] = useState("");
  const [categories, setCategories] = useState<any>([]);

  const now = new Date();
  const prevMonth = new Date(now.setMonth(now.getMonth() - 1));

  const makeTabList = () => {
    const tabListUI = tabLists.map((item, index) => (
      <Tab
        key={`tabs_${index}`}
        className={({ selected }) =>
          classNames(
            "h-full font-medium text-[14px] md:text-[16px] relative px-2 py-2 md:px-8 md:py-4 before:absolute before:left-0 before:bottom-0 before:h-0.5 before:bg-brand before:transition-all before:duration-300 before:ease-in-out",
            "ring-transparent ring-opacity-60 ring-offset-0 ring-offset-transparent focus:outline-none focus:ring-0",
            selected
              ? "text-primary bg-white rounded-t-[8px]"
              : "text-secondary bg-transparent"
          )
        }
      >
        {item}
      </Tab>
    ));
    return (
      <Tab.List className="flex flex-row items-center w-full h-[58px] md:h-[56px]">
        {tabListUI}
      </Tab.List>
    );
  };

  return (
    <div className="w-full h-full bg-gray">
      <div className="w-full flex flex-col">
        {!canViewFeeMgtBusiness ? (
          <div className="flex flex-col items-center justify-center bg-white rounded-[12px] m-4 p-8 text-center shadow-sm">
            <p className="font-manrope text-[16px] font-semibold text-secondary">
              You do not have permission to view business fee management.
            </p>
          </div>
        ) : selectedUser == null ? (
          <div
            className={`${
              invoiceData && "hidden"
            } w-full h-full flex-col p-2 sm:p-4`}
          >
            {" "}
            {/* <p className="text-[25px] sm:text-[32px] font-manrope text-primary font-medium leading-[37.5px] sm:leading-[48px]">
              Fee Management
            </p> */}
            <Tab.Group
              selectedIndex={selectedTabIndex}
              onChange={(tabIdx: number) => setSelectedTabIndex(tabIdx)}
            >
              {makeTabList()}
            </Tab.Group>
            <div className="mt-4 flex items-center justify-between w-full mb-4">
              {selectedTabIndex === 1 ? (
                <FeeBillingBusiness />
              ) : selectedTabIndex === 2 ? (
                <GamblingFeeBillingBusiness />
              ) : (
                <FeeManagementBusinessPage />
              )}
            </div>
          </div>
        ) : (
          <div
            className={`${
              invoiceData && "hidden"
            } flex flex-col w-full p-2 sm:p-4`}
          >
            <div className="flex flex-row items-center justify-between sm:justify-start gap-4">
              <div className="flex flex-row items-center gap-2">
                <Button
                  variant="icon"
                  className="w-[24px] bg-transparent h-[24px]"
                  onClick={() => {
                    setSelectedUserID(-1);
                    setSelectedUser(null);
                  }}
                >
                  <BackCircleIcon className="w-[24px] h-[24px] text-primary" />
                </Button>
                <p className="text-[25px] sm:text-[32px] font-manrope text-primary font-medium leading-[38px] sm:leading-[48px]">
                  {!selectedUser.user_data.first_name &&
                  !selectedUser.user_data.last_name
                    ? "-"
                    : (selectedUser.user_data.first_name ?? " ") +
                      " " +
                      (selectedUser.user_data.last_name ?? " ")}
                </p>
              </div>
              <p
                className={`font-manrope text-[12px] font-medium px-2 rounded-full ${getStatusStyle(
                  selectedUser.status.name
                )}`}
              >
                {capitalizeFirstLetter(selectedUser.status.name)}
              </p>
            </div>
            {/* <UsersContainerPage
          user={selectedUser}
          onSelectedInvoiceData={onSelectedInvoiceData}
        /> */}
          </div>
        )}
      </div>
      {/* {invoiceData && (
    <InvoicePage data={invoiceData!} callback={onBackFromInvoice} />
  )} */}
    </div>
  );
};

export default FeeMgtBusiness;
